import React, { useEffect, useState } from "react";
import emptyList from "../utils/emptyList.png";
import expand from "../utils/expand.png";
import deleteIcon from "../utils/delete.png";
import products from "../utils/products.png";
import ViewLead from "../modals/ViewLead";
import { Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { AiFillDelete } from "react-icons/ai";

const statusMapping = {
  newLead: "New Lead",
  contacted: "Contacted",
  attemptedToContact: "Attempted to Contact",
  // qualified: "Qualified",
  unQualified: "Unqualified",
};

const statusClasses = {
  newLead: "bg-orange-400",
  contacted: "bg-blue-600",
  attemptedToContact: "bg-red-400",
  qualified: "bg-green-400",
  unQualified: "bg-red-600",
};

// const KanbanViewLeads = ({ rows, setRows, onDeleteChecked, groupedRows ,onEditLead , handleInputChange}) => {
const KanbanViewLeads = ({ rows, setRows, onDeleteChecked, onEditLead , handleInputChange, clickedOnEditLead}) => {


  const groupedRows = rows.reduce((acc, row) => {
    acc[row.lead_status] = acc[row.lead_status] || [];
    acc[row.lead_status].push(row);
    return acc;
  }, {});

  console.log('rows:',rows)
  
  useEffect(()=>{
    console.log('groupedRows:',groupedRows)
    setRows(rows)
    console.log('Rows:',rows)
  },[groupedRows])

  // Handle drag and drop
  const onDragStart = (e, leadId, fromStatus) => {
    e.dataTransfer.setData("leadId", leadId);
    e.dataTransfer.setData("fromStatus", fromStatus);
  };

  const onDrop = (e, newStatus) => {
    const leadId = e.dataTransfer.getData("leadId");
    const fromStatus = e.dataTransfer.getData("fromStatus");

    if (fromStatus === newStatus) return; // Skip if the status is unchanged

    // Update the row's status
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === parseInt(leadId, 10) ? { ...row, status: newStatus } : row
      )
    );
  };

  const allowDrop = (e) => {
    e.preventDefault(); // Allow dropping
  };

  
  const calculateAgedDays = (leadEntryTime) => {
    const entryTime = new Date(leadEntryTime);
    const currentTime = new Date();
    const diffInMilliseconds = currentTime - entryTime;

    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(
      (diffInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );

    return `Aged Days: ${diffInDays} d, ${diffInHours} h`;
  };

  const [selectedLead, setSelectedLead] = useState(null); // Track selected lead for the modal
  const [viewLeadModal, setViewLeadModal] = useState(false);

  const handleViewLead = (selectedLead) => {
    console.log('view opened')
    handleKebabMenuClose()
    setSelectedLead(selectedLead);
    console.log("selectedlead 195 handle view:", selectedLead);
    setViewLeadModal(true);   
  };

  const handleDeleteLead = (lead) => {
    console.log("handleDeleteLead:", lead);
    handleKebabMenuClose()
    setSelectedLead(lead);
    // setViewLeadModal(true);
    onDeleteChecked()
  };



    // const deleteSelectedLeads = () => {
    //   console.log('inside deleteSelectedLeads')
    //   const updatedLeads = filteredLeadRows.filter(
    //     (lead) => !selectedLeads.includes(lead.id)
    //   );
    //   setFilteredLeadRows(updatedLeads);
    //   setRows((prevRows) =>
    //     prevRows.filter((lead) => !selectedLeads.includes(lead.id))
    //   );
    //   setSelectedLeads([]); // Clear selected leads after deletion
    //   setShowDeleteModal(false); // Close modal after deletion
    // };

  const closeViewLeadModal = () => {
    console.log("clode lead view modal");
    setViewLeadModal((prev) => !prev);
  };


  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleKebabMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleKebabMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="flex gap-4  mt-2 ">
      {Object.keys(statusMapping).map((status, index) => (
        <div
          key={`${status}-${index}`}
          className="flex-1 bg-gray-100 rounded shadow-md  "
          // role="button"
          // aria-dropeffect="move"
          onDragOver={allowDrop}
          onDrop={(e) => onDrop(e, status)}
        >
          <h2
            className={`text-lg font-normal text-center p-2 mb-2 text-white ${statusClasses[status]} rounded-t`}
          >
            {statusMapping[status]}
          </h2>
          <div className="flex flex-col gap-1 py-1 h-[90vh]  overflow-y-auto scrollbar-hide ">
            {groupedRows[status]?.map((selectedLead, index) =>(
              <div
                key={`${selectedLead.id}-${index}`}
                className="bg-white rounded shadow p-3 mx-2 my-1 hover:bg-gray-50 cursor-grab active:cursor-grabbing"
                draggable
                onDragStart={(e) => {
                  e.currentTarget.classList.add("dragging");
                  e.currentTarget.style.opacity = "1";
                  onDragStart(e, selectedLead.id, selectedLead.status);
                }}
                onDragEnd={(e) => {
                  e.currentTarget.classList.remove("dragging");
                  e.currentTarget.style.opacity = "1";
                }}
              >
                <div className="flex justify-between items-center ">
                  <h3 className="font-normal">{selectedLead.lead_primarycontact}</h3>
                  <div className="flex justify-center items-center gap-1 ">
                    {selectedLead.Cnt>1 && (
                      <img
                        src={products}
                        alt="products-icon"
                        className="w-1 h-1 bg-green-500 text-xs p-1 mb-1 mr-1 rounded-lg "
                      />
                    )}
                    <div>
                      <IconButton onClick={handleKebabMenuClick} sx={{padding:'0px' }}>
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                      sx={{
                        "& .MuiPaper-root": {
                          boxShadow: "0px 2px 2px 0px rgba(74, 74, 86, 0.2)" 
                        }
                      }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleKebabMenuClose}
                      >
                        <MenuItem onClick={handleKebabMenuClose}>
                          <div onClick={() => handleDeleteLead(selectedLead)} className="flex justify-between items-center gap-2">
                            <span>Delete</span>
                            <img
                              
                              src={deleteIcon}
                              alt="delete-icon"
                              className="w-4 h-4 cursor-pointer"
                              />
                          </div>
                        </MenuItem>
                        <MenuItem onClick={() => handleViewLead(selectedLead)}>
                          <div className="flex justify-between items-center gap-2 ">
                            <span>View</span>
                            <img
                              src={expand}
                              alt="expand-icon"
                              className="w-4 h-4 cursor-pointer"
                            />
                          </div>
                        </MenuItem>
                      </Menu>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-600">
                  {selectedLead.lead_organization || "No organization"}
                </p>
                <p className="text-sm text-gray-600">
                  {selectedLead.lead_primarycontacttitle || "No title"}
                </p>
                <p className="text-sm text-gray-600">
                  {selectedLead.lead_email || "No email"}
                </p>
                <p className="text-xs text-center font-thin bg-gray-400 px-0.5 mt-2 rounded-lg text-white">
                  {/* {lead.email || "No email"} */}
                  {calculateAgedDays(selectedLead.lead_entryTime)}
                </p>
              </div>
            ))}

            {!groupedRows[status]?.length && (
              <div className="flex flex-col justify-center items-center text-gray-500">
                <img src={emptyList} alt="emptylist" className="w-32 h-24" />
                <p className="text-gray-400 pb-2 text-center">No leads</p>
              </div>
            )}
          </div>
        </div>
      ))}

      {viewLeadModal && (
        <ViewLead selectedLead={selectedLead} onClose={closeViewLeadModal} onEditLead={onEditLead} 
        clickedOnEditLead={clickedOnEditLead} />
      )}
    </div>
  );
};

export default KanbanViewLeads;
